import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components/macro'
import { t } from 'ttag'
import PropTypes from 'prop-types'
import { Get } from 'api/index'
import { bindActionCreators } from 'redux'
import {
  applyDocumentSearch,
  applyHeatMapSearch,
  applySearch,
  saveDocumentSearch,
  saveSearch
} from 'store/actions/search'
import { show } from 'redux-modal'
import breakpoints from 'assets/stylesheet'
import {
  filtersList,
  regionsList,
  setCurrentSearchable,
  updateSelectedFilters
} from 'store/actions/filters'
import { initialState as initialFilters } from 'store/reducers/filters'
import SearchableMultiSelectHigherLevel from 'components/filters/SearchableMultiSelectHigherLevel'
//import SearchFilterButton from 'components/ui/SearchFilterButton'
import SearchableMultiSelect from 'components/filters/SearchableMultiSelect'
import ProjectLanguages from 'components/filters/ProjectLanguages'
import ProjectDetails from 'components/filters/ProjectDetails'
import MultiSelect from 'components/filters/MultiSelect'
import ProgrammeRelatedMultiSelectPeriod from 'components/filters/ProgrammeRelatedMultiSelectPeriod'
import ProgrammeRelatedMultiSelectType from 'components/filters/ProgrammeRelatedMultiSelectType'
import MultiSelectFields from 'components/filters/MultiSelectFields'
import MultiSelectPartnerType from 'components/filters/MultiSelectPartnerType'
import CARNutsSelector from 'components/filters/CARNutsSelector'
import MultiNutsSelector from 'components/filters/MultiNutsSelector'
import Investments from 'components/filters/Investments'
//import Prizes from 'components/filters/Prizes'
//  import Checkbox from 'components/filters/Checkbox'
import Calls from 'components/filters/Calls'
import Button from 'components/ui/Button'
import SearchableMultiSelectTree from 'components/filters/SearchableMultiSelectTree'
import DocumentTypes from 'components/filters/DocumentTypes'
import Themes from 'components/filters/Themes'
import FreeTextSearch from 'components/filters/FreeTextSearch'
import ProjectBudget from 'components/filters/ProjectBudget'
import ConditionalFreeTextSearch from 'components/filters/ConditionalFreeTextSearch'
import FilterSection from 'components/ui/FilterSection'
import {
  INCLUDED_VALUE,
  PermissionStatusStates,
  SearchableOptions
} from 'store/constants/constants'
import ArrayMultiSelectHigherLevel from 'components/filters/ArrayMultiSelectHigherLevel'
import DocumentLanguages from 'components/filters/DocumentLanguages'
import pako from 'pako'
import ProgrammeHierarchyMultiSelect from 'components/filters/ProgrammeHierarchyMultiSelect'
import NutsSelector from 'components/filters/NutsSelector'
import MacroRegionalStrategiesMultiSelect from 'components/filters/MacroRegionalStrategiesMultiSelect'

const SearchContainer = styled.div`
  transition: all 0.4s ease;
  position: relative;
  left: ${props => (props.isSidebarVisible ? '0' : props.reduced ? '-100%' : '0')};
  display: flex;
  justify-content: center;
  max-width: ${props => (props.fullScreen ? '100%' : props.reduced ? '430px' : '430px')};
  @media (max-width: ${breakpoints.bpTabletPx}) {
    left: ${props => (props.isSidebarVisible ? '0' : '-100%')};
    width: 100%;
    left: ${props => (props.isSidebarVisible ? '0' : props.reduced ? '-100%' : '0')};
    max-width: unset !important;
    background: white;
    min-height: 100%;
    padding-top: 60px;
  }
`

const SearchFilters = styled.div`
  background-color: #eaeaee;
  border-radius: 4px;
  padding: 20px 0 20px 0;
  display: flex;
  flex-direction: column;
  position: relative;
  top: 0px;
  box-shadow:
    0 2px 4px 0 rgba(0, 0, 0, 0.14),
    0 3px 4px 0 rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  padding: ${props => (props.fullScreen ? '60px 0' : '15px 0 15px 15px')};
  bottom: 0;
  height: 100%;
  width: ${props => (props.fullScreen ? '100%' : props.reduced ? '430px' : '430px')};
  @media (max-width: ${breakpoints.bpPhonePx}) {
    max-width: 100% !important;
  }
`
const FilterSectionTitle = styled.h2`
  margin-top: ${props => (props.isDocumentSection ? '0' : '0')} !important;
  font-size: ${props => (props.isSmall ? '16px' : '22px')}!important;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 18px !important;
    margin-top: ${props => (props.isDocumentSection ? '0' : '1rem')} !important;
    margin-bottom: 4px !important;
  }
`
const ButtonWrapper = styled.div`
  position: relative;
`
const CriteriaInfoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`
const Loading = styled.div``
const CriteriaInfoIcon = styled.i`
  font-size: 20px;
  margin: 10px;
  cursor: pointer;
`
const FilterInfoIcon = styled.i`
  font-size: 20px;
  margin-right: 10px;
  cursor: pointer;
`
const ResultsButton = styled(Button)`
  left: 10px;
  bottom: 10px;
  width: 410px;
  z-index: 999;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    width: calc(100vw - 20px);
  }
  display: ${props => (props.isSidebarVisible ? 'block' : 'block')};
`

class SearchComponent extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      currentFilterId: '',
      showAdvanced: false,
      orderby: this.props.orderby,
      resetOrder: this.props.resetOrder,
      orderbyUpdate: this.props.orderbyUpdate,
      radioChecked: '',
      modalOpen: false
    }
    this.loadSavedFilters = this.loadSavedFilters.bind(this)
    this.locationError = this.locationError.bind(this)
    this.closeFilter = this.closeFilter.bind(this)
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
    this.locationSuccess = this.locationSuccess.bind(this)
    this.handleCollapseSidebar = this.handleCollapseSidebar.bind(this)
    this.handleResetAllFilters = this.handleResetAllFilters.bind(this)
  }

  componentDidMount() {
    const {
      setCurrentSearchable: setCurrentSearchableAction,
      filtersList: filtersListAction,
      regionsList: regionsListAction,
      searchPage,
      fullScreen
    } = this.props
    const regionParams = {
      geometry: false
    }
    let filterParams = {
      list: true,
      with_published: 'project'
    }
    if (searchPage === SearchableOptions.PROGRAMMES) {
      filterParams = {
        list: true,
        with_published: 'programme'
      }
    }
    setCurrentSearchableAction(searchPage)
    regionsListAction(regionParams)
    const { hash } = window.location
    let useThemeFilter = false
    const urlParams = new URLSearchParams(window.location.search)
    const programmeId = urlParams.get('programme_id')
    if (hash.startsWith('#search:')) {
      this.loadSavedFilters(hash.substring(8))
    } else if (programmeId) {
      this.loadProgrammeSearch(programmeId)
    } else if (searchPage === SearchableOptions.PROJECTS) {
      if (hash.startsWith('#theme:')) {
        useThemeFilter = true
      } else {
        navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError)
      }
    } else {
      this.applySearchFilters(searchPage, true)
    }
    filtersListAction(filterParams).then(() => {
      const { setCurrentFilters } = this.props
      setCurrentFilters(this.initFilters())
      if (useThemeFilter) {
        this.loadThemeFilter(hash.substring(7))
      }
    })
    if (!fullScreen) {
      this.setState({
        advancedVisible: true
      })
    }
  }

  loadSavedFilters(filtersIdentifier) {
    const { updateSelectedFilters: updateSelectedFiltersAction, searchPage } = this.props
    try {
      const intitialSelectedFilters = initialFilters.selectedFilters
      const restored = JSON.parse(pako.inflate(atob(filtersIdentifier), { to: 'string' }))

      // In the case that, the schema of the search has changed since the hash
      // has been created, make sure the new filter fields exist in
      // the restored filter object.
      Object.keys(intitialSelectedFilters[searchPage]).forEach(key => {
        if (!restored[key]) {
          restored[key] = intitialSelectedFilters[searchPage][key]
        } else {
          Object.keys(intitialSelectedFilters[searchPage][key]).forEach(key2 => {
            if (!restored[key][key2]) {
              restored[key][key2] = intitialSelectedFilters[searchPage][key][key2]
            }
          })
        }
      })
      const data = {
        wholeFilterObject: restored
      }
      // eslint-disable-next-line
      updateSelectedFiltersAction(data)
      // A dirty way of making the search filters to be applied
      // AFTER the above updateSelectedFiltersAction has been
      // applied to the redux state. setTimeout skips 1 update
      // iteration if no time has been applied to it. It might
      // be wise to change this to a more "appropriate"
      // solution in the future.
      setTimeout(() => this.handleSavedFilterResult(searchPage))
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  async loadProgrammeSearch(programmeId) {
    const {
      updateSelectedFilters: updateSelectedFiltersAction,
      filters: {
        selectedFilters: {
          projects: { programmes }
        }
      },
      searchPage
    } = this.props
    try {
      // A dirty way of making the search filters to be applied
      // AFTER the above updateSelectedFiltersAction has been
      // applied to the redux state. setTimeout skips 1 update
      // iteration if no time has been applied to it. It might
      // be wise to change this to a more "appropriate"
      // solution in the future.
      const programme = await Get(`/api/programme/${programmeId}`)
      const data = {
        filterId: 'programmes',
        filterValue: {
          ...programmes,
          available: [{ id: programmeId, label: programme.title }]
        },
        isHigherLevelFilter: true
      }
      await updateSelectedFiltersAction(data)
      setTimeout(() => this.handleSavedFilterResult(searchPage))
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  loadThemeFilter(themeId) {
    const {
      searchPage,
      filters: { availableFilters },
      updateSelectedFilters: updateSelectedFiltersAction
    } = this.props
    const selectedThemes = availableFilters.projects.themes.filter(
      theme => theme.id === parseInt(themeId, 10)
    )
    if (selectedThemes.length > 0) {
      const returnValue = {
        list: [{ id: selectedThemes[0].id, label: selectedThemes[0].title }],
        type: 'or'
      }
      const data = {
        filterType: SearchableOptions.PROJECTS,
        filterId: 'themes',
        filterValue: returnValue
      }
      updateSelectedFiltersAction(data)
      setTimeout(() => this.applySearchFilters(searchPage, true))
    } else {
      this.applySearchFilters(searchPage, true)
    }
  }

  handleSavedFilterResult(searchPage) {
    const {
      filters: { selectedFilters }
    } = this.props
    if (
      searchPage === SearchableOptions.PROJECTS &&
      selectedFilters[SearchableOptions.PROJECTS].location != null
    ) {
      this.handleLocationForSavedSearch()
    } else {
      this.applySearchFilters(searchPage, true)
    }
  }

  locationSuccess(position) {
    const { searchPage, updateSelectedFilters: updateSelectedFiltersAction } = this.props
    const filterValue = {
      lng: position.coords.longitude,
      lat: position.coords.latitude
    }
    const data = {
      filterId: 'location',
      filterValue,
      isHigherLevelFilter: true
    }
    updateSelectedFiltersAction(data)
    setTimeout(() => this.applySearchFilters(searchPage, true))
  }

  locationError() {
    const { searchPage, updateSelectedFilters: updateSelectedFiltersAction } = this.props
    const data = {
      filterId: 'location',
      filterValue: null,
      isHigherLevelFilter: true
    }
    updateSelectedFiltersAction(data)
    setTimeout(() => this.applySearchFilters(searchPage, true))
  }

  initFilters() {
    const {
      filters: { availableFilters, regions, currentSearchable }
    } = this.props
    const filters = {
      projects: [
        {
          name: 'Project keywords',
          id: 'either-this-or-that',
          info: 'text-search-in-projects-and-documents-what-is-it-how-does-it-work',
          filters: []
        },
        {
          name: 'Project keywords field',
          main: true,
          info: 'text-search-in-projects-and-documents-what-is-it-how-does-it-work',
          type: 'reduced',
          hideInfo: true,
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            },
            {
              type: 'search',
              name: 'fields',
              title: 'Fields to include in project keywords',
              class: 'fields-exc',
              info: 'text-search-in-projects-and-documents-what-fields-does-it-include',
              componentType: MultiSelectFields,
              componentName: 'MultiSelectFields',
              values: ['fields'],
              data: availableFilters.search.fields,
              advanced: true
            },
            {
              type: 'languages',
              title: 'Languages to include in project keywords',
              name: 'languages',
              class: 'languages-exc',
              info: 'languages-to-include-in-projects-and-documents-text-search-why-use-this-filter',
              componentType: ProjectLanguages,
              values: ['project_lang'],
              data: availableFilters.general.project_languages,
              customTop: '-85px',
              advanced: true
            }
          ]
        },
        {
          name: 'Project documents',
          info: 'documents-what-is-a-document-for-keep-eu-how-can-an-exact-document-be-found-in-keep-eu',
          id: 'either-this-or-that',
          filters: []
        },
        {
          name: 'Documents',
          main: true,
          info: 'documents-what-is-a-document-for-keep-eu-how-can-an-exact-document-be-found-in-keep-eu',
          style: 'low-impact-filters',
          hideInfo: true,
          filters: [
            {
              type: 'documents',
              title: '',
              componentType: FreeTextSearch,
              values: ['name'],
              customTop: '-353px',
              unToggleable: true
            }
          ]
        },
        {
          name: 'Additional document filters',
          main: true,
          advanced: true,
          filters: [
            {
              type: 'documents',
              title: 'Projects with specific types of documents',
              class: 'doc-types-exc',
              name: 'document types',
              info: 'type-of-documents',
              componentType: DocumentTypes,
              values: ['types'],
              keyWord: 'name',
              data: availableFilters.projects.attachments.types,
              customTop: '-309px'
            },
            {
              type: 'documents',
              title: 'Projects with documents attached of specific languages',
              class: 'doc-languages-exc',
              name: 'document languages',
              componentType: DocumentLanguages,
              values: ['document_lang'],
              data: availableFilters.general.attachment_languages,
              info: 'language-search-for-documents-in-specific-languages-only-why-use-this-filter'
            },
            {
              type: 'translation_languages',
              title: 'Projects with documents in specific language(s) only',
              componentType: ProjectLanguages,
              values: ['project_desc_lang'],
              data: availableFilters.general.project_languages,
              customTop: '-85px',
              info: 'language-search-for-documents-in-specific-languages-only-why-use-this-filter'
            }
          ]
        },
        {
          name: 'Funding',
          info: 'funding-criteria-what-is-including-in-projects-and-documents-funding-criteria',
          advanced: false,
          filters: [
            {
              type: 'partners',
              title: 'Projects with partners from countries/regions',
              keyWord: 'name',
              componentType: MultiNutsSelector,
              values: ['nuts_lead', 'nuts_partner', 'nuts_search_type'],
              data: regions,
              customTop: '-440px',
              info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches'
            },
            {
              type: 'programmes',
              title: 'Projects from programming periods',
              componentType: ProgrammeRelatedMultiSelectPeriod,
              values: ['period'],
              data: availableFilters.programmes.period,
              keyWord: 'title',
              info: 'programming-period-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Projects from specific types of programmes',
              componentType: ProgrammeRelatedMultiSelectType,
              values: ['type'],
              data: availableFilters.programmes.type,
              keyWord: 'title',
              info: 'type-of-programme-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Projects from specific programmes',
              componentType: ProgrammeHierarchyMultiSelect,
              values: ['available'],
              keyWord: 'title',
              info: 'programmes-what-does-it-mean-within-the-scope-of-keep'
            }
          ]
        },
        {
          name: 'Thematic focus',
          //info: 'funding-criteria-what-is-including-in-projects-and-documents-funding-criteria',
          advanced: true,
          filters: [
            {
              type: 'projects',
              title: 'Projects working specific thematic fields (out of 42 keep.eu themes)',
              componentType: Themes,
              values: ['themes'],
              data: availableFilters.projects.themes,
              keyWord: 'title',
              info: 'thematics-what-are-they-how-are-they-assigned-to-projects'
            }
          ]
        },
        {
          name: 'Times and budget',
          info: 'times-and-budget-criteria-what-filters-are-included',
          hideInfo: true,
          advanced: true,
          filters: [
            {
              type: 'projects',
              title: 'Project times criteria',
              componentType: ProjectDetails,
              values: [
                'status',
                'only_projects_with_documents',
                'project_details.start',
                'project_details.without_start',
                'project_details.end',
                'project_details.without_end'
              ],
              data: availableFilters.projects,
              info: 'project-times-criteria-what-filters-are-included'
            },
            {
              type: 'projects',
              title: 'Project budget criteria',
              componentType: ProjectBudget,
              values: ['project_budget.range', 'project_budget.without_budget'],
              data: availableFilters.projects,
              info: 'project-budget-criteria-what-filters-are-included'
            }
          ]
        },
        {
          name: 'Partners',
          info: 'partner-what-is-it',
          advanced: true,
          filters: [
            {
              type: 'partners',
              title: 'Projects with public or private partners',
              instant: false,
              componentType: MultiSelectPartnerType,
              values: ['status'],
              data: availableFilters.partners.status,
              customTop: '-123px',
              info: 'public-private-partners-what-concepts-are-at-play-here'
            },
            {
              type: 'partners',
              title: 'Projects with partners that are specific types of organisations',
              componentType: MultiSelect,
              values: ['type'],
              data: availableFilters.partners.organisation_type,
              customTop: '-123px',
              info: 'public-private-partners-what-concepts-are-at-play-here'
            }
          ]
        },
        {
          name: 'Contribution to programme objectives, indicators',
          info: 'thematic-criteria-in-keep-eu-why-so-many',
          advanced: true,
          filters: []
        },
        {
          name: '2021-2027',
          info: '2021-2027-subcategory',
          accordion: true,
          show: true,
          advanced: true,
          filters: [
            {
              type: 'policy_objective_interreg_specific_objective',
              macroType: 'contribution_2021_2027',
              title: 'Policy objectives & Interreg-specific objectives',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['policy_objective_interreg_specific_objective'],
              data: availableFilters.contribution_2021_2027
                .policy_objective_interreg_specific_objective,
              keyWord: 'content',
              customTop: '-119px',
              info: 'policy-objectives-interreg-specific-objectives-and-their-specific-objectives'
            },
            {
              type: 'specific_objectives',
              macroType: 'contribution_2021_2027',
              title: 'Specific objectives',
              info: 'policy-objectives-interreg-specific-objectives-and-their-specific-objectives',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['specific_objectives'],
              data: availableFilters.contribution_2021_2027.specific_objectives,
              keyWord: 'content',
              customTop: '-150px'
            },
            {
              type: 'intervention',
              macroType: 'contribution_2021_2027',
              title: 'Types of intervention',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['intervention'],
              data: availableFilters.contribution_2021_2027.intervention,
              keyWord: 'content',
              customTop: '-58px',
              info: 'types-of-intervention-what-are-those-why-do-they-matter'
            } /*,
            {
              type: 'common_output_indicators',
              macroType: 'contribution_2021_2027',
              title: 'Common output indicators',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['common_output_indicators'],
              data: availableFilters.contribution_2021_2027.common_output_indicators,
              keyWord: 'content',
              customTop: '-119px',
              info: 'common-output-and-result-indicators-what-are-they'
            },
             {
              type: 'common_result_indicators',
              macroType: 'contribution_2021_2027',
              title: 'Common result indicators',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['common_result_indicators'],
              data: availableFilters.contribution_2021_2027.common_result_indicators,
              keyWord: 'content',
              customTop: '-119px',
              info: 'common-output-and-result-indicators-what-are-they'
            }*/
          ]
        },
        {
          name: '2014-2020',
          info: '2014-2020-subcategory',
          accordion: true,
          open: false,
          show: true,
          advanced: true,
          filters: [
            {
              type: 'specific_objectives',
              macroType: 'contribution_2014_2020',
              title: 'Thematic Objectives - Investment Priorities',
              subTitle: '(Interreg projects only)',
              info: 'thematic-objectives-what-are-they-what-is-their-use',
              componentType: SearchableMultiSelectTree,
              values: ['thematic_objectives'],
              data: availableFilters.contribution_2014_2020.specific_objectives.thematic_objectives,
              keyWord: 'content'
            },
            {
              type: 'thematic_objectives_eni',
              macroType: 'contribution_2014_2020',
              title: 'Thematic Objectives',
              subTitle: '(ENI CBC programmes only)',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['thematic_objectives_eni'],
              data: availableFilters.contribution_2014_2020.thematic_objectives_eni,
              keyWord: 'content',
              info: 'thematic-objectives-eni-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              macroType: 'contribution_2014_2020',
              title: 'Thematic Priorities',
              subTitle: '(Interreg-IPA CBC projects only)',
              componentType: SearchableMultiSelect,
              values: ['thematic_priorities'],
              data: availableFilters.contribution_2014_2020.specific_objectives.thematic_priorities,
              keyWord: 'content',
              customTop: '-119px',
              info: 'thematic-priorities-ipa-cbc-what-are-they'
            }
          ]
        },
        {
          name: 'Additional filters',
          advanced: true,
          filters: [
            {
              type: 'projects',
              title: 'Investment in infrastructure',
              instant: true,
              subTitle: '(choose to see only projects that include investment in infrastructure)',
              componentType: Investments,
              values: ['investments'],
              info: 'investments-in-infrastructure-what-is-this-filter-why-use-it'
            },
             /*{
              type: 'projects',
              title: 'Projects with prizes',
              instant: true,
              subTitle: '(choose to see only projects that have won prizes)',
              componentType: Prizes,
              values: ['prizes'],
              info: 'projects-with-prizes-what-is-this-filter-why-use-it'
            },*/
            {
              type: 'projects',
              title: 'Macro-regional strategies',
              componentType: MacroRegionalStrategiesMultiSelect,
              values: ['macro_regional_strategies'],
              data: [
                { id: INCLUDED_VALUE, label: 'Included' },
                { id: 'eusbsr', label: 'Only EUSBSR projects' },
                { id: 'eusdr', label: 'Only EUSDR projects' },
                { id: 'eusalp', label: 'Only EUSALP projects' }
              ],
              keyWord: 'label',
              info: 'macro-regional-strategies-what-are-they'
            }
            /*,
            {
              type: 'projects',
              title: 'Projects with relevant mentions or prizes',
              componentType: Checkbox,
              instant: true,
              values: 'prizes',
              customTop: '-85px',
              info: 'language-search-data-in-specific-languages-only-why-use-this-filter',
            }*/
          ]
        },
        {
          name: 'Advanced search',
          id: 'advanced-search-item',
          filters: []
        }
      ],
      programmes: [
        {
          name: 'Programme name',
          filters: []
        },
        {
          name: 'Text search',
          main: true,
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            }
          ]
        },
        {
          name: 'Basic criteria',
          info: 'basic-criteria-in-keep-eu-searches-what-is-relevant-about-this-set-of-filters',
          filters: [
            {
              type: 'programmes',
              title: 'Types of programme',
              info: 'type-of-programme-what-is-it',
              componentType: ProgrammeRelatedMultiSelectType,
              values: ['type'],
              data: availableFilters.programmes.type,
              keyWord: 'title'
            },
            {
              type: 'programmes',
              title: 'Programming periods',
              componentType: ProgrammeRelatedMultiSelectPeriod,
              values: ['period'],
              data: availableFilters.programmes.period,
              keyWord: 'title',
              info: 'programming-period-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Countries/regions',
              keyWord: 'name',
              componentType: NutsSelector,
              values: ['nuts'],
              data: regions,
              customTop: '-189px',
              info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches'
            },
            {
              type: 'programmes',
              title: 'Show only programmes with calls ongoing',
              componentType: Calls,
              instant: true,
              noInfoButton: true,
              values: ['call'],
              info: 'only-outgoing-calls'
            }
          ]
        },
        {
          name: 'Thematic criteria',
          info: 'thematic-criteria-in-keep-eu-why-so-many',
          advanced: true,
          filters: []
        },
        {
          name: '2021-2027 programmes',
          info: '2021-2027-programmes',
          accordion: true,
          show: true,
          advanced: true,
          filters: [
            {
              type: 'policy_objective_interreg_specific_objective',
              macroType: 'contribution_2021_2027',
              title: 'Policy objectives & Interreg-specific objectives',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['policy_objective_interreg_specific_objective'],
              data: availableFilters.contribution_2021_2027
                .policy_objective_interreg_specific_objective,
              keyWord: 'content',
              customTop: '-119px',
              info: 'policy-objectives-interreg-specific-objectives-and-their-specific-objectives'
            },
            {
              type: 'specific_objectives',
              title: 'Specific objectives',
              macroType: 'contribution_2021_2027',
              info: 'policy-objectives-interreg-specific-objectives-and-their-specific-objectives',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['specific_objectives'],
              data: availableFilters.contribution_2021_2027.specific_objectives,
              keyWord: 'content',
              customTop: '-150px'
            },
            {
              type: 'intervention',
              macroType: 'contribution_2021_2027',
              title: 'Types of intervention',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['intervention'],
              data: availableFilters.contribution_2021_2027.intervention,
              keyWord: 'content',
              customTop: '-58px',
              info: 'types-of-intervention-what-are-those-why-do-they-matter'
            },
            {
              type: 'common_output_indicators',
              macroType: 'contribution_2021_2027',
              title: 'Common output indicators',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['common_output_indicators'],
              data: availableFilters.contribution_2021_2027.common_output_indicators,
              keyWord: 'content',
              customTop: '-119px',
              info: 'common-output-and-result-indicators-what-are-they'
            },
            {
              type: 'common_result_indicators',
              macroType: 'contribution_2021_2027',
              title: 'Common result indicators',
              info: 'common-output-and-result-indicators-what-are-they',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['specific_objectives'],
              data: availableFilters.contribution_2021_2027.common_result_indicators,
              keyWord: 'content',
              customTop: '-173px'
            }
          ]
        },
        {
          name: '2014-2020 programmes',
          info: '2014-2020-programmes',
          accordion: true,
          show: true,
          advanced: true,
          filters: [
            {
              type: 'specific_objectives',
              macroType: 'contribution_2014_2020',
              title: 'Thematic Objectives - Investment Priorities',
              subTitle: '(Interreg programmes only)',
              info: 'thematic-objectives-what-are-they-what-is-their-use',
              componentType: SearchableMultiSelectTree,
              values: ['thematic_objectives'],
              data: availableFilters.contribution_2014_2020.specific_objectives.thematic_objectives,
              keyWord: 'content',
              customTop: '-150px'
            },
            {
              type: 'thematic_objectives_eni',
              macroType: 'contribution_2014_2020',
              title: 'Thematic Objectives',
              subTitle: '(ENI CBC programmes only)',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['thematic_objectives_eni'],
              data: availableFilters.contribution_2014_2020.thematic_objectives_eni,
              keyWord: 'content',
              customTop: '-58px',
              info: 'thematic-objectives-eni-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              macroType: 'contribution_2014_2020',
              title: 'Thematic Priorities',
              subTitle: '(Interreg-IPA CBC programmes only)',
              componentType: SearchableMultiSelect,
              values: ['thematic_priorities'],
              data: availableFilters.contribution_2014_2020.specific_objectives.thematic_priorities,
              keyWord: 'content',
              customTop: '-119px',
              info: 'thematic-priorities-ipa-cbc-what-are-they'
            },
            {
              type: 'common_output_indicators',
              macroType: 'contribution_2014_2020',
              title: 'Common output indicators',
              subTitle: '(Interreg and Interreg-IPA CBC programmes only)',
              componentType: ArrayMultiSelectHigherLevel,
              values: ['common_output_indicators'],
              data: availableFilters.contribution_2014_2020.common_output_indicators,
              customTop: '-173px',
              info: 'common-output-and-result-indicators-what-are-they'
            },
            {
              type: 'thematic_objectives_eni_common_output_indicators',
              macroType: 'contribution_2014_2020',
              title: 'Common output indicators',
              subTitle: '(2014-2020 ENI CBC programmes only)',
              componentType: ArrayMultiSelectHigherLevel,
              values: ['thematic_objectives_eni_common_output_indicators'],
              data: availableFilters.contribution_2014_2020.common_output_indicators_eni,
              keyWord: 'content',
              customTop: '-238px',
              info: 'common-output-indicators-2014-2020-eni-cbc-what-are-they'
            }
          ]
        },
        {
          name: 'Advanced search',
          id: 'advanced-search-item',
          filters: []
        }
      ],
      partners: [
        {
          name: 'Text search',
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            }
          ]
        },
        {
          name: 'Basic criteria',
          info: 'basic-criteria-in-keep-eu-searches-what-is-relevant-about-this-set-of-filters',
          filters: [
            {
              type: 'partners',
              title: 'Public/private',
              componentType: MultiSelect,
              values: ['status'],
              data: availableFilters.partners.status,
              info: 'public-private-partners-what-concepts-are-at-play-here'
            },
            {
              type: 'partners',
              title: 'Countries/regions',
              keyWord: 'name',
              componentType: NutsSelector,
              values: ['nuts'],
              data: regions,
              customTop: '-189px',
              info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches'
            }
          ]
        },
        {
          name: 'Experience',
          info: 'past-experience-criteria-in-keep-eu-searches-how-to-use-this-set-of-filters',
          filters: [
            {
              type: 'partners',
              title: 'Lead partner or project partner',
              componentType: MultiSelect,
              values: ['type'],
              data: availableFilters.partners.type.filter(type => type !== 'associate'),
              info: 'partner-what-is-it'
            },
            {
              type: 'projects',
              title: 'Experience (per keep.eu themes)',
              info: 'thematics-what-are-they-how-are-they-assigned-to-projects',
              componentType: Themes,
              values: ['themes'],
              data: availableFilters.projects.themes,
              keyWord: 'title',
              customTop: '-80px'
            },
            {
              type: 'programmes',
              title: 'Programming periods',
              componentType: ProgrammeRelatedMultiSelectPeriod,
              values: ['period'],
              data: availableFilters.programmes.period,
              keyWord: 'title',
              info: 'programming-period-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Types of programme',
              info: 'type-of-programme-what-is-it',
              componentType: ProgrammeRelatedMultiSelectType,
              values: ['type'],
              data: availableFilters.programmes.type,
              keyWord: 'title'
            },
            {
              type: 'programmes',
              title: 'Programmes',
              info: 'programmes-what-does-it-mean-within-the-scope-of-keep',
              componentType: ProgrammeHierarchyMultiSelect,
              values: ['available'],
              data: availableFilters.programmes.available,
              keyWord: 'title'
            },
            {
              type: 'specific_objectives',
              macroType: 'contribution_2014_2020',
              title: 'Experience per Thematic Objective/Investment Priority',
              subTitle: '(2014-2020 Interreg only)',
              info: 'thematic-objectives-what-are-they-what-is-their-use',
              componentType: SearchableMultiSelectTree,
              values: ['thematic_objectives'],
              data: availableFilters.contribution_2014_2020.specific_objectives.thematic_objectives,
              keyWord: 'content'
            },
            {
              type: 'thematic_objectives_eni',
              macroType: 'contribution_2014_2020',
              title: 'Experience per Thematic Objective',
              subTitle: '(2014-20 ENI CBC only)',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['thematic_objectives_eni'],
              data: availableFilters.contribution_2014_2020.thematic_objectives_eni,
              keyWord: 'content',
              customTop: '-100px',
              info: 'thematic-objectives-eni-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              macroType: 'contribution_2014_2020',
              title: 'Experience per Thematic Priority',
              subTitle: '(2014-20 Interreg-IPA cross-border only)',
              componentType: SearchableMultiSelect,
              values: ['thematic_priorities'],
              data: availableFilters.contribution_2014_2020.specific_objectives.thematic_priorities,
              keyWord: 'content',
              customTop: '-153px',
              info: 'thematic-priorities-ipa-cbc-what-are-they'
            }
          ]
        }
      ],
      countries_and_regions: [
        {
          name: 'Text search',
          main: true,
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            }
          ]
        },
        {
          name: 'Select geographic scope',
          info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches',
          filters: [
            {
              keyWord: 'name',
              componentType: CARNutsSelector,
              values: [],
              data: [],
              customTop: '-276px',
              unToggleable: true
            }
          ]
        }
      ]
    }
    return filters[currentSearchable]
  }

  async handleSearchSubmit(buttonWhenReduced) {
    const {
      filters: { currentSearchable, selectedFilters },
      updateSelectedFilters: updateSelectedFiltersAction,
      orderby,
      fullScreen,
      reduced
    } = this.props
    if (selectedFilters && selectedFilters.projects && selectedFilters.projects.location) {
      const data = {
        filterId: 'location',
        filterValue: null,
        isHigherLevelFilter: true
      }
      await updateSelectedFiltersAction(data)
    }
    this.setState({ orderby: orderby })
    this.props.resetOrder(orderby)
    this.applySearchFilters(currentSearchable, false, null, true, orderby, buttonWhenReduced)
    if (!fullScreen && reduced) {
      this.setState({
        advancedVisible: false
      })
    } else {
      this.setState({
        advancedVisible: true
      })
    }
  }

  handleCollapseSidebar() {
    const { onToggleSideBar } = this.props
    onToggleSideBar(true)
  }

  handleResetAllFilters() {
    const {
      updateSelectedFilters: updateSelectedFiltersAction,
      filters: { availableFilters },
      searchPage
    } = this.props
    const intitialSelectedFilters = initialFilters.selectedFilters
    var fieldsArray = []
    // reset search filters as it should be
    Object.keys(availableFilters.search.fields).map(i => {
      fieldsArray.push(availableFilters.search.fields[i][0])
    })
    fieldsArray = searchPage === 'projects' ? fieldsArray : []
    var copied = {
      ...intitialSelectedFilters[searchPage],
      search: {
        ...intitialSelectedFilters[searchPage].search,
        fields: fieldsArray
      }
    }
    const data = {
      wholeFilterObject: copied
    }
    updateSelectedFiltersAction(data)
    // A dirty way of making the search filters to be applied
    // AFTER the above updateSelectedFiltersAction has been
    // applied to the redux state. setTimeout skips 1 update
    // iteration if no time has been applied to it. It might
    // be wise to change this to a more "appropriate"
    // solution in the future.
    setTimeout(() => this.handleSavedFilterResult(searchPage))
  }

  handleLocationForSavedSearch() {
    navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
      if (permissionStatus.state === PermissionStatusStates.DENIED) {
        this.handleSavedSearchLocationError()
      } else if (permissionStatus.state === PermissionStatusStates.GRANTED) {
        navigator.geolocation.getCurrentPosition(this.handleSavedSearchLocationSuccess)
      } else if (permissionStatus.state === PermissionStatusStates.PROMPT) {
        navigator.geolocation.getCurrentPosition(
          this.handleSavedSearchLocationSuccess,
          this.handleSavedSearchLocationError
        )
      }
    })
  }

  handleSavedSearchLocationSuccess(position) {
    const {
      updateSelectedFilters: updateSelectedFiltersAction,
      onLocationPermissionResult,
      searchPage
    } = this.props
    const filterValue = {
      lng: position.coords.longitude,
      lat: position.coords.latitude
    }
    const data = {
      filterId: 'location',
      filterValue,
      isHigherLevelFilter: true
    }
    updateSelectedFiltersAction(data)
    onLocationPermissionResult(true)
    setTimeout(() => this.applySearchFilters(searchPage, true))
  }

  handleSavedSearchLocationError() {
    const { show: showAction, onLocationPermissionResult } = this.props
    onLocationPermissionResult(false)
    showAction('infoModal', {
      title: t`Location criterion`,
      message: t`In order to search nearby projects, you need to enable location permission in your browser's settings. 
      This search will be done without the location filter`
    })
    this.locationError()
  }

  applySearchFilters(searchable, initial = false, n, clicked, orderby, buttonWhenReduced) {
    const {
      filters: { selectedFilters },
      applySearch: applySearchAction,
      applyDocumentSearch: applyDocumentSearchAction,
      applyHeatMapSearch: applyHeatMapSearchAction,
      saveSearch: saveSearchAction,
      saveDocumentSearch: saveDocumentSearchAction,
      onToggleSideBar,
      onLocationPermissionResult,
      show: showAction
    } = this.props
    const data = {
      currentSearchable: searchable,
      body: selectedFilters[searchable],
      page: 1,
      orderby
    }

    if (selectedFilters[SearchableOptions.PROJECTS].location != null) {
      onLocationPermissionResult(true)
    } else {
      onLocationPermissionResult(false)
    }

    applySearchAction(data).then(response => {
      saveSearchAction(selectedFilters[searchable])
      if (searchable === SearchableOptions.PROGRAMMES) {
        if (clicked && response.value.count > process.env.REACT_APP_PROGRAMMES_TOO_MANY_RESULTS) {
          showAction('infoModal', {
            title: t`Too many results`,
            message: t`Too many results? Refine your search with the filters on the left.`,
            //  missing part: , or upload the results to Excel and view all the data in a spreadsheet
            scrolltop: true
          })
        }
      }
      if (searchable === SearchableOptions.PROJECTS) {
        const foundProjectIds = response.value ? response.value.project_ids : []
        if (foundProjectIds.length > 0) {
          if (clicked && foundProjectIds.length > process.env.REACT_APP_PROJECTS_TOO_MANY_RESULTS) {
            showAction('infoModal', {
              title: t`Too many results`,
              message: t`Too many results? Refine your search with the filters on the left, or upload the results to Excel and view all the data in a spreadsheet`,
              scrolltop: true
            })
          }
          applyHeatMapSearchAction({
            body: {
              ...selectedFilters[searchable],
              all_partnerships: true
            }
          })

          const selectedLanguages = selectedFilters[
            SearchableOptions.PROJECTS
          ].documents.document_lang.map(language => language.id)
          const selectedTypes = selectedFilters[SearchableOptions.PROJECTS].documents.types
          const freeTextSearch = selectedFilters[SearchableOptions.PROJECTS].documents.name
          const documentData = {
            body: {
              documents: {
                projects: foundProjectIds,
                ...(selectedLanguages.length > 0 && {
                  languages: selectedLanguages
                }),
                ...(selectedTypes.length > 0 && {
                  types: selectedTypes
                }),
                ...(freeTextSearch &&
                  freeTextSearch.length > 0 && {
                    name: freeTextSearch
                  })
              }
            }
          }
          applyDocumentSearchAction(documentData).then(() => {
            saveDocumentSearchAction(documentData)
          })
        }
      }
    })
    if (!initial) {
      window.scrollTo(0, 0)
      this.setState({
        currentFilterId: '',
        radioChecked: '',
        modalOpen: false
      })
      onToggleSideBar(false, buttonWhenReduced)
    }
  }

  async onCriteriaInfoClick(title, message) {
    const { show: showAction } = this.props
    const data = await fetch(`/wp-json/wp/v2/pages?slug=${message}`)
    const jsonData = await data.json()
    const msg = jsonData[0].content.rendered
    showAction('infoModal', { message: msg })
  }

  handleFilterButtonClick(filterId) {
    const { currentFilterId } = this.state
    if (filterId === currentFilterId) {
      this.setState({
        currentFilterId: ''
      })
    } else {
      this.setState({
        currentFilterId: filterId
      })
    }
  }

  accordionChanged(filterId, event) {
    const { radioChecked, currentFilterId } = this.state
    this.setState({
      modalOpen: false
    })
    if (event.target.checked) {
      if (filterId === currentFilterId) {
        this.setState({
          currentFilterId: ''
        })
      } else {
        this.setState({
          currentFilterId: filterId
        })
      }
    } else {
      if (currentFilterId === radioChecked) {
        setTimeout(
          function () {
            this.setState({
              currentFilterId: '',
              radioChecked: ''
            })
          }.bind(this),
          300
        )
      }
    }
    if (filterId === radioChecked) {
      this.setState({
        radioChecked: ''
      })
    } else {
      this.setState({
        radioChecked: filterId
      })
    }
  }

  showAdvanced(status) {
    const { fullScreen, reduced } = this.props
    if (status) {
      this.setState({
        advancedVisible: false
      })
    } else {
      if (!fullScreen && reduced) {
        this.setState({
          advancedVisible: false
        })
      } else {
        this.setState({
          advancedVisible: true
        })
      }
    }
  }

  triggerButton(value) {
    if (value) {
      this.setState({
        modalOpen: true
      })
    }
  }

  checkYears(event) {
    var e = event
    e.target.checked = false
  }

  renderHeader() {
    const { searchPage } = this.props
    switch (searchPage) {
      case SearchableOptions.PROJECTS:
        return t`Projects and documents`
      case SearchableOptions.PROGRAMMES:
        return t`Programmes`
      case SearchableOptions.PARTNERS:
        return t`Partners`
      case SearchableOptions.COUNTRIES_AND_REGIONS:
        return t`Countries and regions`
      default:
        return null
    }
  }

  closeFilter() {
    this.setState({
      currentFilterId: '',
      radioChecked: '',
      modalOpen: false
    })
  }

  render() {
    const {
      filters: { isPending, submitEnabled },
      isSidebarVisible,
      fullScreen,
      reduced,
      currentFilters
    } = this.props
    const { currentFilterId, advancedVisible, radioChecked, modalOpen } = this.state
    const filtersPending = isPending
    const filters = (
      <div className="container-filters-gap">
        {currentFilters.map((item, index) => (
          <FilterSection
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            isDocumentSection={item.name === 'Documents'}
            className={
              'hidden-control' +
              (item.advanced ? (!advancedVisible ? ' advanced-hidden' : '') : '') +
              ' heading-' +
              item.name.replace(/ /g, '_')
            }
          >
            {item.name && !item.accordion && (
              <FilterSectionTitle
                isDocumentSection={item.name === 'Documents'}
                isSmall={item.id == 'and-or' || item.id == 'either-this-or-that'}
              >
                {item.id == 'advanced-search-item' && (
                  <div
                    className={'advanced-filters' + (!advancedVisible ? '' : ' expanded')}
                    onClick={() => this.showAdvanced(advancedVisible)}
                  >
                    {!advancedVisible ? 'See all search filters' : 'See less search filters'}
                  </div>
                )}
                {item.id == 'advanced-search-item' || item.main || (item.id == 'and-or' && !reduced)
                  ? ''
                  : item.name}
                {item.info && !item.hideInfo && (
                  <CriteriaInfoIcon
                    onClick={() => this.onCriteriaInfoClick(item.name, item.info)}
                    className="far fa-question-circle"
                  />
                )}
              </FilterSectionTitle>
            )}
            {item.accordion && (
              <div className="accordion-container-c years">
                <div className="bottoncione">
                  <input
                    type="checkbox"
                    className="accordion-checker"
                    id={`accordion-${item.name}_${index}`}
                    defaultChecked={item.show}
                    onChange={null}
                    hidden
                  />
                  <label htmlFor={`accordion-${item.name}_${index}`}>{item.name}</label>
                  <div className="filter-container">
                    {item.filters.map((filter, idx) => {
                      const FilterComponent = filter.componentType
                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={`${item.name}_${idx}`} className="item">
                          {filter.unToggleable ? (
                            <FilterComponent
                              type={filter.type}
                              macroType={filter.macroType}
                              filterData={filter.data}
                              values={filter.values}
                              title={filter.title}
                              info={filter.info}
                              keyWord={filter.keyWord ? filter.keyWord : null}
                              customTop={filter.customTop ? filter.customTop : null}
                              onClose={this.closeFilter}
                              showFilter={`${item.name}_${idx}` === currentFilterId}
                              applySearch={() => this.handleSearchSubmit(reduced)}
                              submitEnabled={submitEnabled}
                              sidebarReduced={reduced}
                              modalReset={modalOpen}
                              triggerButton={value => this.triggerButton(value)}
                            />
                          ) : (
                            <ButtonWrapper>
                              <CriteriaInfoWrapper>
                                <div className="accordion-container-c">
                                  <FilterInfoIcon
                                    onClick={() =>
                                      this.onCriteriaInfoClick(filter.title, filter.info)
                                    }
                                    className="far fa-question-circle"
                                  />
                                  <div className="bottoncione">
                                    <input
                                      type="checkbox"
                                      className="accordion-checker"
                                      checked={
                                        radioChecked === `${item.name.replace(/ /g, '_')}_${idx}`
                                      }
                                      id={`accordion-${item.name.replace(/ /g, '_')}_${idx}`}
                                      onChange={event =>
                                        this.accordionChanged(
                                          `${item.name.replace(/ /g, '_')}_${idx}`,
                                          event
                                        )
                                      }
                                      hidden
                                    />
                                    <label
                                      htmlFor={`accordion-${item.name.replace(/ /g, '_')}_${idx}`}
                                    >
                                      <div className="title">{filter.title}</div>
                                      {filter.subTitle ? (
                                        <div className="sub-title">{filter.subTitle}</div>
                                      ) : null}
                                    </label>
                                    <div
                                      className={
                                        (reduced ? 'reducedd ' : '') +
                                        'filter-container side-container'
                                      }
                                    >
                                      <FilterComponent
                                        type={filter.type}
                                        macroType={filter.macroType}
                                        filterData={filter.data}
                                        values={filter.values}
                                        title={filter.title}
                                        info={filter.info}
                                        keyWord={filter.keyWord ? filter.keyWord : null}
                                        customTop={filter.customTop ? filter.customTop : null}
                                        onClose={this.closeFilter}
                                        showFilter={
                                          `${item.name.replace(/ /g, '_')}_${idx}` ===
                                          currentFilterId
                                        }
                                        sidebarReduced={reduced}
                                        modalReset={modalOpen}
                                        triggerButton={value => this.triggerButton(value)}
                                      />
                                    </div>
                                  </div>
                                  <div className="container-selected-filters">
                                    <FilterComponent
                                      type={filter.type}
                                      macroType={filter.macroType}
                                      filterData={filter.data}
                                      values={filter.values}
                                      title={filter.title}
                                      info={filter.info}
                                      keyWord={filter.keyWord ? filter.keyWord : null}
                                      customTop={filter.customTop ? filter.customTop : null}
                                      selection={true}
                                    />
                                  </div>
                                </div>
                              </CriteriaInfoWrapper>
                            </ButtonWrapper>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}
            <div className={'filter-wrapper-cute ' + item.name.replace(/ /g, '_')}>
              {!item.accordion &&
                item.filters.map((filter, idx) => {
                  const FilterComponent = filter.componentType
                  var advanced = filter.advanced
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <div
                      className={
                        filter.class +
                        '_wrapper ' +
                        (advanced ? ' hidden-control ' : '') +
                        (advanced ? (!advancedVisible ? ' advanced-hidden' : '') : '') +
                        ' heading-' +
                        item.name.replace(/ /g, '_')
                      }
                      key={`${item.name}_${idx}`}
                    >
                      {filter.unToggleable ? (
                        <FilterComponent
                          type={filter.type}
                          macroType={filter.macroType}
                          filterData={filter.data}
                          values={filter.values}
                          title={filter.title}
                          info={filter.info}
                          keyWord={filter.keyWord ? filter.keyWord : null}
                          customTop={filter.customTop ? filter.customTop : null}
                          onClose={this.closeFilter}
                          showFilter={`${item.name}_${idx}` === currentFilterId}
                          applySearch={() => this.handleSearchSubmit(reduced)}
                          submitEnabled={submitEnabled}
                          sidebarReduced={reduced}
                          modalReset={modalOpen}
                          triggerButton={value => this.triggerButton(value)}
                        />
                      ) : (
                        <ButtonWrapper className={`filter-wrapper ${filter.class}`}>
                          {filter.instant ? (
                            <div className="instant-field">
                              {!filter.noInfoButton && (
                                <FilterInfoIcon
                                  onClick={() =>
                                    this.onCriteriaInfoClick(filter.title, filter.info)
                                  }
                                  className="far fa-question-circle"
                                />
                              )}
                              <FilterComponent
                                position="reduced"
                                type={filter.type}
                                macroType={filter.macroType}
                                filterData={filter.data}
                                values={filter.values}
                                title={filter.title}
                                info={filter.info}
                                keyWord={filter.keyWord ? filter.keyWord : null}
                                customTop={filter.customTop ? filter.customTop : null}
                                onClose={this.closeFilter}
                                showFilter={true}
                                applySearch={() => this.handleSearchSubmit(reduced)}
                                submitEnabled={submitEnabled}
                                hide={true}
                                subTitle={filter.subTitle}
                                instant={filter.instant}
                                sidebarReduced={reduced}
                                modalReset={modalOpen}
                                triggerButton={value => this.triggerButton(value)}
                              />
                            </div>
                          ) : item.type === 'reduced' ? (
                            <CriteriaInfoWrapper className={`reduced-container ${filter.class}`}>
                              <div className="accordion-container-c">
                                <FilterInfoIcon
                                  onClick={() =>
                                    this.onCriteriaInfoClick(filter.title, filter.info)
                                  }
                                  className="far fa-question-circle"
                                />
                                {filter.componentName === 'MultiSelectFields' ? (
                                  <FilterComponent
                                    position="reduced"
                                    macroType={filter.macroType}
                                    type={filter.type}
                                    filterData={filter.data}
                                    values={filter.values}
                                    info={filter.info}
                                    title={filter.title}
                                    keyWord={filter.keyWord ? filter.keyWord : null}
                                    customTop={filter.customTop ? filter.customTop : null}
                                    showFilter={filter.name + '_' + idx == currentFilterId}
                                    applySearch={() => this.handleSearchSubmit(reduced)}
                                    submitEnabled={submitEnabled}
                                    sidebarReduced={reduced}
                                    modalReset={modalOpen}
                                    triggerButton={value => this.triggerButton(value)}
                                    radioChecked={radioChecked}
                                    identifier={`${filter.name}_${idx}`}
                                    change={(item, event) => this.accordionChanged(item, event)}
                                  />
                                ) : (
                                  <>
                                    <div className="bottoncione">
                                      <input
                                        type="checkbox"
                                        className="accordion-checker"
                                        checked={radioChecked === `${filter.name}_${idx}`}
                                        id={`accordion-${filter.name}_${idx}`}
                                        onChange={event =>
                                          this.accordionChanged(`${filter.name}_${idx}`, event)
                                        }
                                        hidden
                                      />
                                      <label htmlFor={`accordion-${filter.name}_${idx}`}>
                                        {filter.title}
                                      </label>
                                      <div
                                        className={
                                          (reduced ? 'reducedd ' : '') +
                                          'filter-container side-container'
                                        }
                                      >
                                        <div
                                          className={`list-group-item`}
                                          onClick={() =>
                                            this.handleFilterButtonClick(`${item.name}_${idx}`)
                                          }
                                          name={filter.title}
                                        >
                                          <FilterComponent
                                            position="reduced"
                                            macroType={filter.macroType}
                                            type={filter.type}
                                            filterData={filter.data}
                                            values={filter.values}
                                            title={filter.title}
                                            info={filter.info}
                                            keyWord={filter.keyWord ? filter.keyWord : null}
                                            customTop={filter.customTop ? filter.customTop : null}
                                            onClose={this.closeFilter}
                                            showFilter={filter.name + '_' + idx == currentFilterId}
                                            applySearch={() => this.handleSearchSubmit(reduced)}
                                            submitEnabled={submitEnabled}
                                            hide={true}
                                            selection={false}
                                            sidebarReduced={reduced}
                                            modalReset={modalOpen}
                                            triggerButton={value => this.triggerButton(value)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="container-selected-filters">
                                      <FilterComponent
                                        type={filter.type}
                                        macroType={filter.macroType}
                                        filterData={filter.data}
                                        values={filter.values}
                                        title={filter.title}
                                        info={filter.info}
                                        keyWord={filter.keyWord ? filter.keyWord : null}
                                        customTop={filter.customTop ? filter.customTop : null}
                                        selection={true}
                                        hide={false}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                            </CriteriaInfoWrapper>
                          ) : (
                            <CriteriaInfoWrapper>
                              <div className="accordion-container-c">
                                <FilterInfoIcon
                                  onClick={() =>
                                    this.onCriteriaInfoClick(filter.title, filter.info)
                                  }
                                  className="far fa-question-circle"
                                />
                                <div className="bottoncione">
                                  <input
                                    type="checkbox"
                                    className="accordion-checker"
                                    checked={radioChecked === `${item.name}_${idx}`}
                                    id={`accordion-${item.name}_${idx}`}
                                    onChange={event =>
                                      this.accordionChanged(`${item.name}_${idx}`, event)
                                    }
                                    hidden
                                  />
                                  <label htmlFor={`accordion-${item.name}_${idx}`}>
                                    {filter.title}
                                  </label>
                                  <div
                                    className={
                                      (reduced ? 'reducedd ' : '') +
                                      'filter-container side-container'
                                    }
                                  >
                                    <FilterComponent
                                      type={filter.type}
                                      macroType={filter.macroType}
                                      filterData={filter.data}
                                      values={filter.values}
                                      title={filter.title}
                                      info={filter.info}
                                      keyWord={filter.keyWord ? filter.keyWord : null}
                                      customTop={filter.customTop ? filter.customTop : null}
                                      onClose={this.closeFilter}
                                      showFilter={`${item.name}_${idx}` === currentFilterId}
                                      sidebarReduced={reduced}
                                      modalReset={modalOpen}
                                      triggerButton={value => this.triggerButton(value)}
                                    />
                                  </div>
                                </div>
                                <div className="container-selected-filters">
                                  <FilterComponent
                                    type={filter.type}
                                    macroType={filter.macroType}
                                    filterData={filter.data}
                                    values={filter.values}
                                    title={filter.title}
                                    info={filter.info}
                                    keyWord={filter.keyWord ? filter.keyWord : null}
                                    customTop={filter.customTop ? filter.customTop : null}
                                    selection={true}
                                  />
                                </div>
                              </div>
                            </CriteriaInfoWrapper>
                          )}
                        </ButtonWrapper>
                      )}
                    </div>
                  )
                })}
            </div>
          </FilterSection>
        ))}
        <FilterSection className="actions-row">
          <ResultsButton
            size="large"
            disabled={!submitEnabled}
            isSidebarVisible={isSidebarVisible}
            onClick={() => this.handleSearchSubmit(reduced)}
          >
            {reduced ? t`Show Results` : t`Show results`}
          </ResultsButton>
          {/*!reduced && (
           <div className="collapse" title="Collapse sidebar"  onClick={this.handleCollapseSidebar}>
              <i className="far fa-arrow-from-right"></i>
            </div>
          )*/}
          {!reduced && (
            <ResultsButton size="large" title="Reset search" onClick={this.handleResetAllFilters}>
              Reset All Filters
            </ResultsButton>
          )}
        </FilterSection>
      </div>
    )

    return (
      <SearchContainer
        isSidebarVisible={isSidebarVisible}
        fullScreen={fullScreen}
        reduced={reduced}
        className={fullScreen ? 'bar-full-screen' : 'bar-reduced'}
      >
        <SearchFilters
          isSidebarVisible={isSidebarVisible}
          fullScreen={fullScreen}
          reduced={reduced}
        >
          <div className="container-full-filters">
            {filtersPending ? (
              <Loading>
                <div className="loading-spinner">
                  <div className=" lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </Loading>
            ) : (
              filters
            )}
          </div>
        </SearchFilters>
      </SearchContainer>
    )
  }
}

SearchComponent.propTypes = {
  filtersList: PropTypes.func,
  regionsList: PropTypes.func,
  setCurrentSearchable: PropTypes.func,
  applySearch: PropTypes.func,
  applyDocumentSearch: PropTypes.func,
  applyHeatMapSearch: PropTypes.func,
  saveSearch: PropTypes.func,
  saveDocumentSearch: PropTypes.func,
  searchPage: PropTypes.string,
  show: PropTypes.func,
  orderby: PropTypes.string,
  resetOrder: PropTypes.func,
  orderbyUpdate: PropTypes.func,
  filters: PropTypes.shape({
    availableFilters: PropTypes.any,
    regionsList: PropTypes.array,
    currentSearchable: PropTypes.string,
    selectedFilters: PropTypes.object,
    isPending: PropTypes.bool,
    submitEnabled: PropTypes.bool,
    regions: PropTypes.array
  }),
  isSidebarVisible: PropTypes.bool,
  fullScreen: PropTypes.bool,
  reduced: PropTypes.bool,
  onToggleSideBar: PropTypes.func,
  onLocationPermissionResult: PropTypes.func,
  setCurrentFilters: PropTypes.func,
  currentFilters: PropTypes.array,
  updateSelectedFilters: PropTypes.func,
  radioChecked: PropTypes.string
}

const mapStateToProps = ({ filters }) => ({
  filters
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      filtersList,
      setCurrentSearchable,
      applySearch,
      applyDocumentSearch,
      applyHeatMapSearch,
      show,
      regionsList,
      updateSelectedFilters,
      saveSearch,
      saveDocumentSearch
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent)
